module.exports = __webpack_public_path__ + "static/img/logo71.888df83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo71.png
// module id = 6o85
// module chunks = 1